import type { CurrentUser } from './generated/types';

/** Match a new cookie's actual /me principal, never copy a capability from a previous session. */
export function isVerifiedSessionProjection(
  authenticated: CurrentUser,
  projected: CurrentUser,
  roleId: string | null,
): boolean {
  return Boolean(
    authenticated?.id &&
      authenticated.companyId &&
      projected.id === authenticated.id &&
      projected.companyId === authenticated.companyId &&
      (projected.roleView?.roleId ?? null) === roleId &&
      (roleId === null || projected.roleViewEnabled === true),
  );
}
